import {Component, forwardRef, Injector, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-period-schedule-single-select-column",
    styleUrls: ["./period-schedule-single-select-column.component.scss"],
    templateUrl: "./period-schedule-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => PeriodScheduleSingleSelectColumnComponent), multi: true}
    ]
})
export class PeriodScheduleSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + ".id";
        this.labelField = this.field + ".name";
    }
}
